<template lang="pug">
.title-wrapper
  .flex.justify-between
    a.h2.title(
      data-test-id="slidein-title"
      target="_blank"
      :href="`/bookings/${booking.Key}/details`"
      ) {{ headerTitle }}
    .flex.justify-end
      button.close-button(
        data-test-id="slidein-close-button"
        @click="hideOverview"
        )
        BriqIcon(:name="`icon-close`")
  .title-time(
    data-test-id="slidein-header-time"
  ) {{ bookingProductStartEndTime }}
  .title-date(
    data-test-id="slidein-header-date"
  ) {{ bookingProductDate }}
</template>

<script>
import { mapActions } from 'vuex'
import {
  bookingProductStartEndTime,
  bookingProductDate,
} from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'

export default {
  name: 'OverviewHeader',
  props: {
    headerData: {
      type: Object,
    },
    booking: {
      type: Object,
    },
  },
  computed: {
    bookingProductStartEndTime() {
      return bookingProductStartEndTime(
        this.headerData?.FromDateTime,
        this.headerData?.ToDateTime,
        this.$locale,
        this.$timezone,
      )
    },
    bookingProductDate() {
      return bookingProductDate(this.headerData.FromDateTime, this.$locale)
    },
    headerTitle() {
      return `${this.headerData?.ProductName} - ${this.headerData?.ResourceName}`
    },
  },
  methods: {
    ...mapActions('planboardModule', ['hideOverview']),
  },
}
</script>

<style lang="stylus">
.title-wrapper
  margin-bottom 12px

  .title
    font-weight 500
    margin-bottom 5px

  .title-time
    font-size 16px
    font-weight 400
    line-height 24px

  .title-date
    font-size 12px
    line-height 16px

  .close-button
    cursor pointer
    margin-top 9px
    display flex
    border none
    outline none
</style>
